import React from 'react';

const Intro = () => {
  return <div>광장기획전 소개</div>;
};

export default Intro;
